export { use404DisplayAnalytics } from "./use-404-display-analytics";
